import { render, staticRenderFns } from "./template.vue?vue&type=template&id=367f2018&scoped=true&"
import script from "@/Views/Global/InternalModulesView/component.ts?vue&type=script&lang=ts&"
export * from "@/Views/Global/InternalModulesView/component.ts?vue&type=script&lang=ts&"
import style0 from "@/Views/Global/InternalModulesView/style.scss?vue&type=style&index=0&id=367f2018&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367f2018",
  null
  
)

export default component.exports